import httpClient from "../config/HttpClient";
import { CLIENTS_URL } from "../routes";
import { ClientFilter } from "./ClientFilter";

export interface ClientBulkUpdateForm {
  clientState: string | null;
  validFrom: string;
  validTo: string;
  responsibleUser: string | null;
}

export const defaultBulkUpdateForm: Readonly<ClientBulkUpdateForm> = {
  clientState: null,
  validFrom: "",
  validTo: "",
  responsibleUser: null,
};

interface BulkUpdateRequest {
  filter: Omit<ClientFilter, 'state'> & {
    state: string | null;
  };
  form: ClientBulkUpdateForm;
}

class ClientBulkUpdateModel implements ClientBulkUpdateForm {
  clientState: string | null = null;
  validFrom: string = "";
  validTo: string = "";
  responsibleUser: string | null = null;

  constructor(partial: Partial<ClientBulkUpdateForm> = {}) {
    Object.assign(this, { ...defaultBulkUpdateForm, ...partial });
  }

  static normalizeEmptyString<T extends string | null>(value: T): T {
    return (value === "" ? null : value) as T;
  }

  static createRequest(filter: ClientFilter, form: ClientBulkUpdateForm): BulkUpdateRequest {
    return {
      filter: {
        ...filter,
        state: this.normalizeEmptyString(filter.state)
      },
      form: {
        ...form,
        clientState: this.normalizeEmptyString(form.clientState)
      }
    };
  }

  static async updateList(filter: ClientFilter, form: ClientBulkUpdateForm): Promise<number> {
    const request = this.createRequest(filter, form);
    const response = await httpClient.patch<number>(`${CLIENTS_URL}/bulk`, request);
    return response.data;
  }
}

// Export both the class and a default export for backward compatibility
export { ClientBulkUpdateModel };
export default ClientBulkUpdateModel;
